import { c as _c } from "react/compiler-runtime";
import type { FC, SVGProps } from "react";
export const ArrowsActionIcon: FC<SVGProps<SVGSVGElement>> = props => {
  const $ = _c(5);
  let t0;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <title>Arrows Action Icon</title>;
    t1 = <path d="M13 11L22 2M22 2H16.6562M22 2V7.34375" strokeLinecap="round" strokeLinejoin="round" />;
    t2 = <path d="M22 12C22 16.714 22 19.0711 20.5355 20.5355C19.0711 22 16.714 22 12 22C7.28595 22 4.92893 22 3.46447 20.5355C2 19.0711 2 16.714 2 12C2 7.28595 2 4.92893 3.46447 3.46447C4.92893 2 7.28595 2 12 2" strokeLinecap="round" />;
    $[0] = t0;
    $[1] = t1;
    $[2] = t2;
  } else {
    t0 = $[0];
    t1 = $[1];
    t2 = $[2];
  }
  let t3;
  if ($[3] !== props) {
    t3 = <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="currentColor" strokeWidth={1.5} {...props}>{t0}{t1}{t2}</svg>;
    $[3] = props;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
};